<template>
  <div class="card emoji-picker shadow-sm">
    <!-- Category Navigation -->
    <div class="card-header p-2 bg-white border-bottom">
      <div class="d-flex justify-content-between">
        <button
          v-for="(category, index) in categories"
          :key="index"
          class="btn btn-link btn-sm p-1 text-secondary"
          :title="category.label"
          @click="setActiveCategory(category.id)"
        >
          <i :class="category.icon"></i>
        </button>
      </div>
    </div>

    <!-- Search Bar -->
    <div class="p-2 border-bottom">
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="searchTerm"
        placeholder="Suche nach Emoji"
      >
    </div>

    <!-- Emoji Grid -->
    <div class="emoji-content p-2">
      <h6 class="text-muted small mb-2">{{ activeCategoryLabel }}</h6>
      <div class="emoji-grid">
        <button
          v-for="(emoji, index) in filteredEmojis"
          :key="index"
          class="btn btn-emoji p-1"
          @click="selectEmoji(emoji)"
          @mouseenter="setHoverEmoji(emoji)"
        >
          {{ emoji.emoji }}
        </button>
      </div>
    </div>

    <!-- Footer -->
    <div class="card-footer p-2 bg-white d-flex justify-content-between align-items-center">
      <span class="emoji-preview small text-muted">
        {{ hoverEmoji ? `${hoverEmoji.emoji}` : '😀' }}
      </span>
      <!-- <div class="d-flex align-items-center">
        <span class="small text-muted me-2">Hautfarbe</span>
        <div class="dropdown">
          <button class="btn btn-emoji p-0" data-bs-toggle="dropdown">
            👍
          </button>
          <ul class="dropdown-menu">
            <li v-for="tone in skinTones" :key="tone.emoji">
              <button class="dropdown-item p-1" @click="selectSkinTone(tone)">
                {{ tone.emoji }}
              </button>
            </li>
          </ul>
        </div>
      </div> -->
    </div>
    <div class="emoji-picker-arrow"></div>
  </div>
</template>

<script>
export default {
  name: 'EmojiPicker',

  data() {
    return {
      searchTerm: '',
      activeCategory: 'smileys',
      hoverEmoji: null,
      selectedSkinTone: null,
      categories: [
        { id: 'smileys', icon: 'bi bi-emoji-smile', label: 'Smileys & Emotionen' },
        { id: 'people', icon: 'bi bi-people', label: 'Menschen & Körper' },
        /* { id: 'food', icon: 'bi bi-cup-hot', label: 'Essen & Trinken' },
        { id: 'activities', icon: 'bi bi-controller', label: 'Aktivitäten' },
        { id: 'objects', icon: 'bi bi-lightbulb', label: 'Objekte' },
        { id: 'travel', icon: 'bi bi-car-front', label: 'Reisen & Orte' },
        { id: 'symbols', icon: 'bi bi-hash', label: 'Symbole' },
        { id: 'flags', icon: 'bi bi-flag', label: 'Flaggen' } */
      ],
      skinTones: [
        { emoji: '👍', name: 'standard' },
        { emoji: '👍🏻', name: 'hell' },
        { emoji: '👍🏼', name: 'mittel-hell' },
        { emoji: '👍🏽', name: 'mittel' },
        { emoji: '👍🏾', name: 'mittel-dunkel' },
        { emoji: '👍🏿', name: 'dunkel' }
      ],
      emojisByCategory: {
        smileys: [
          { emoji: '😀', name: 'grinsend' },
          { emoji: '😃', name: 'lächelnd' },
          { emoji: '😄', name: 'lachen' },
          { emoji: '😁', name: 'grinsen' },
          { emoji: '😅', name: 'schwitzen_lächeln' },
          { emoji: '😂', name: 'freudentränen' },
          { emoji: '🤣', name: 'lachend_am_boden' },
          { emoji: '😊', name: 'errötet' },
          { emoji: '😇', name: 'unschuldig' },
          { emoji: '🙂', name: 'leicht_lächelndes_gesicht' },
          { emoji: '🙃', name: 'kopfüber_gesicht' },
          { emoji: '😉', name: 'zwinkern' },
          { emoji: '😌', name: 'erleichtert' },
          { emoji: '😍', name: 'herzchenaugen' },
          { emoji: '🥰', name: 'lächelndes_gesicht_mit_herzen' },
          { emoji: '😘', name: 'kussherz' },
          { emoji: '😗', name: 'küssend' },
          { emoji: '😙', name: 'küssend_lächelnde_augen' },
          { emoji: '😚', name: 'küssend_geschlossene_augen' },
          { emoji: '😋', name: 'lecker' },
          { emoji: '😛', name: 'zunge_raus' },
          { emoji: '😝', name: 'zunge_raus_geschlossene_augen' },
          { emoji: '😜', name: 'zunge_raus_zwinkern' },
          { emoji: '🤪', name: 'verrücktes_gesicht' },
          { emoji: '🤨', name: 'hochgezogene_augenbraue' },
          { emoji: '🧐', name: 'monokel_gesicht' },
          { emoji: '🤓', name: 'nerd_gesicht' },
          { emoji: '😎', name: 'sonnenbrille' },
          { emoji: '🤩', name: 'sternenaugen' },
          { emoji: '🥳', name: 'party_gesicht' },
          { emoji: '😏', name: 'verschmitzt' },
          { emoji: '😒', name: 'genervt' }
        ],
        people: [
          { emoji: '👶', name: 'baby' },
          { emoji: '👧', name: 'mädchen' },
          { emoji: '👦', name: 'junge' },
          { emoji: '👩', name: 'frau' },
          { emoji: '👨', name: 'mann' },
          { emoji: '👴', name: 'älterer_mann' },
          { emoji: '👵', name: 'ältere_frau' },
          { emoji: '👨‍⚕️', name: 'arzt' },
          { emoji: '👩‍⚕️', name: 'ärztin' },
          { emoji: '👨‍🏫', name: 'lehrer' },
          { emoji: '👩‍🏫', name: 'lehrerin' },
          { emoji: '👨‍💻', name: 'techniker' },
          { emoji: '👩‍💻', name: 'technikerin' },
          { emoji: '👨‍🍳', name: 'koch' },
          { emoji: '👩‍🍳', name: 'köchin' },
          { emoji: '👮‍♂️', name: 'polizist' },
          { emoji: '👮‍♀️', name: 'polizistin' },
          { emoji: '🧑‍🚒', name: 'feuerwehrperson' },
          { emoji: '👨‍🎨', name: 'künstler' },
          { emoji: '👩‍🎨', name: 'künstlerin' },
          { emoji: '🤷‍♂️', name: 'schulterzucken_mann' },
          { emoji: '🤷‍♀️', name: 'schulterzucken_frau' },
          { emoji: '🙋‍♂️', name: 'hand_heben_mann' },
          { emoji: '🙋‍♀️', name: 'hand_heben_frau' },
          { emoji: '💃', name: 'tänzerin' },
          { emoji: '🕺', name: 'tänzer' },
          { emoji: '👫', name: 'paar' },
          { emoji: '👪', name: 'familie' },
          { emoji: '🧑‍🤝‍🧑', name: 'personen_händchen_haltend' },
          { emoji: '👥', name: 'silhouetten' },
          { emoji: '🫂', name: 'umarmung' },
          { emoji: '👋', name: 'winkende_hand' },
          { emoji: '🤚', name: 'erhobene_hand' },
          { emoji: '👌', name: 'ok_hand' },
          { emoji: '✌️', name: 'victory' },
          { emoji: '🤘', name: 'rock_on' },
          { emoji: '🤟', name: 'ich_liebe_dich_geste' },
          { emoji: '🙏', name: 'gefaltete_hände' },
          { emoji: '💪', name: 'bizeps' },
          { emoji: '🦾', name: 'mechanischer_arm' }
        ],
        food: [
          { emoji: '🍎', name: 'roter_apfel' },
          { emoji: '🍐', name: 'birne' },
          { emoji: '🍊', name: 'mandarine' },
          { emoji: '🍋', name: 'zitrone' },
          { emoji: '🍌', name: 'banane' },
          { emoji: '🍉', name: 'wassermelone' },
          { emoji: '🍇', name: 'weintrauben' },
          { emoji: '🍓', name: 'erdbeere' },
          { emoji: '🫐', name: 'blaubeeren' },
          { emoji: '🥝', name: 'kiwi' },
          { emoji: '🍅', name: 'tomate' },
          { emoji: '🥑', name: 'avocado' },
          { emoji: '🥦', name: 'brokkoli' },
          { emoji: '🥕', name: 'karotte' },
          { emoji: '🌽', name: 'mais' },
          { emoji: '🌶️', name: 'chili' },
          { emoji: '🥨', name: 'brezel' },
          { emoji: '🥖', name: 'baguette' },
          { emoji: '🧀', name: 'käse' },
          { emoji: '🥚', name: 'ei' },
          { emoji: '🍗', name: 'hähnchenschenkel' },
          { emoji: '🍖', name: 'fleisch' },
          { emoji: '🍔', name: 'hamburger' },
          { emoji: '🍟', name: 'pommes' },
          { emoji: '🍕', name: 'pizza' },
          { emoji: '🌭', name: 'hot_dog' },
          { emoji: '🥪', name: 'sandwich' },
          { emoji: '🌮', name: 'taco' },
          { emoji: '🍜', name: 'nudeln' },
          { emoji: '🍣', name: 'sushi' },
          { emoji: '🍙', name: 'onigiri' },
          { emoji: '🍰', name: 'kuchen' },
          { emoji: '🧁', name: 'cupcake' },
          { emoji: '🍪', name: 'keks' },
          { emoji: '🍫', name: 'schokolade' },
          { emoji: '🍦', name: 'softeis' },
          { emoji: '☕', name: 'kaffee' },
          { emoji: '🍵', name: 'tee' },
          { emoji: '🥤', name: 'getränk' },
          { emoji: '🍷', name: 'wein' }
        ],
        activities: [
          { emoji: '⚽', name: 'fussball' },
          { emoji: '🏀', name: 'basketball' },
          { emoji: '🏈', name: 'football' },
          { emoji: '⚾', name: 'baseball' },
          { emoji: '🎾', name: 'tennis' },
          { emoji: '🏐', name: 'volleyball' },
          { emoji: '🎱', name: 'billard' },
          { emoji: '🎮', name: 'gamepad' },
          { emoji: '🎲', name: 'würfel' },
          { emoji: '♟️', name: 'schach' },
          { emoji: '🎭', name: 'theater' },
          { emoji: '🎨', name: 'kunst' },
          { emoji: '🎬', name: 'film' },
          { emoji: '🎤', name: 'mikrofon' },
          { emoji: '🎧', name: 'kopfhörer' },
          { emoji: '🎸', name: 'gitarre' },
          { emoji: '🎹', name: 'klavier' },
          { emoji: '🎪', name: 'zirkus' },
          { emoji: '🎯', name: 'dartscheibe' },
          { emoji: '🎳', name: 'bowling' }
        ],
        objects: [
          { emoji: '📱', name: 'smartphone' },
          { emoji: '💻', name: 'laptop' },
          { emoji: '⌚', name: 'uhr' },
          { emoji: '📷', name: 'kamera' },
          { emoji: '🔋', name: 'batterie' },
          { emoji: '💡', name: 'glühbirne' },
          { emoji: '🔨', name: 'hammer' },
          { emoji: '✂️', name: 'schere' },
          { emoji: '🔑', name: 'schlüssel' },
          { emoji: '🔒', name: 'schloss' },
          { emoji: '📚', name: 'bücher' },
          { emoji: '✏️', name: 'bleistift' },
          { emoji: '📎', name: 'büroklammer' },
          { emoji: '📌', name: 'stecknadel' },
          { emoji: '🎁', name: 'geschenk' },
          { emoji: '🛍️', name: 'einkaufstaschen' },
          { emoji: '🔮', name: 'kristallkugel' },
          { emoji: '🎈', name: 'luftballon' },
          { emoji: '🎊', name: 'konfetti' },
          { emoji: '🗿', name: 'moai' }
        ],
        travel: [
          { emoji: '🚗', name: 'auto' },
          { emoji: '🚕', name: 'taxi' },
          { emoji: '🚌', name: 'bus' },
          { emoji: '✈️', name: 'flugzeug' },
          { emoji: '🚂', name: 'dampflok' },
          { emoji: '⛴️', name: 'fähre' },
          { emoji: '🚲', name: 'fahrrad' },
          { emoji: '🏔️', name: 'berg' },
          { emoji: '🏖️', name: 'strand' },
          { emoji: '🌋', name: 'vulkan' },
          { emoji: '🗽', name: 'freiheitsstatue' },
          { emoji: '🗼', name: 'tokyo_tower' },
          { emoji: '🏰', name: 'schloss' },
          { emoji: '⛩️', name: 'schrein' },
          { emoji: '🏦', name: 'bank' },
          { emoji: '🏨', name: 'hotel' },
          { emoji: '🏪', name: 'convenience_store' },
          { emoji: '⛪', name: 'kirche' },
          { emoji: '🕌', name: 'moschee' },
          { emoji: '🌇', name: 'sonnenuntergang' }
        ],
        symbols: [
          { emoji: '❤️', name: 'herz' },
          { emoji: '💔', name: 'gebrochenes_herz' },
          { emoji: '☮️', name: 'peace' },
          { emoji: '✝️', name: 'kreuz' },
          { emoji: '☪️', name: 'stern_und_halbmond' },
          { emoji: '🕉️', name: 'om' },
          { emoji: '☯️', name: 'yin_yang' },
          { emoji: '✡️', name: 'davidstern' },
          { emoji: '⚛️', name: 'atom' },
          { emoji: '☢️', name: 'radioaktiv' },
          { emoji: '📛', name: 'namensschild' },
          { emoji: '⭕', name: 'kreis' },
          { emoji: '❌', name: 'kreuz' },
          { emoji: '⛔', name: 'verbot' },
          { emoji: '✅', name: 'häkchen' },
          { emoji: '⚠️', name: 'warnung' },
          { emoji: '♻️', name: 'recycling' },
          { emoji: '💱', name: 'währungstausch' },
          { emoji: '➕', name: 'plus' },
          { emoji: '💲', name: 'dollar' }
        ],
        flags: [
          { emoji: '🏳️', name: 'weisse_flagge' },
          { emoji: '🏴', name: 'schwarze_flagge' },
          { emoji: '🏁', name: 'zielflagge' },
          { emoji: '🚩', name: 'rote_flagge' },
          { emoji: '🏳️‍🌈', name: 'regenbogen_flagge' },
          { emoji: '🇩🇪', name: 'deutschland' },
          { emoji: '🇦🇹', name: 'österreich' },
          { emoji: '🇨🇭', name: 'schweiz' },
          { emoji: '🇪🇺', name: 'eu' },
          { emoji: '🇬🇧', name: 'grossbritannien' },
          { emoji: '🇫🇷', name: 'frankreich' },
          { emoji: '🇮🇹', name: 'italien' },
          { emoji: '🇪🇸', name: 'spanien' },
          { emoji: '🇵🇹', name: 'portugal' },
          { emoji: '🇺🇸', name: 'usa' },
          { emoji: '🇨🇦', name: 'kanada' },
          { emoji: '🇯🇵', name: 'japan' },
          { emoji: '🇰🇷', name: 'südkorea' },
          { emoji: '🇦🇺', name: 'australien' },
          { emoji: '🇧🇷', name: 'brasilien' }
        ]
      }
    }
  },

  computed: {
    activeCategoryLabel() {
      const category = this.categories.find(c => c.id === this.activeCategory);
      return category ? category.label : '';
    },

    filteredEmojis() {
      let emojis = this.emojisByCategory[this.activeCategory] || [];

      if (this.searchTerm) {
        const search = this.searchTerm.toLowerCase();
        emojis = emojis.filter(emoji =>
          emoji.name.includes(search) || emoji.emoji.includes(search)
        );
      }

      return emojis;
    }
  },

  methods: {
    setActiveCategory(categoryId) {
      this.activeCategory = categoryId;
      this.searchTerm = '';
    },

    selectEmoji(emoji) {
      this.$emit('select', emoji.emoji);
    },

    setHoverEmoji(emoji) {
      this.hoverEmoji = emoji;
    },

    selectSkinTone(tone) {
      this.selectedSkinTone = tone;
    }
  }
}
</script>

<style scoped>

.emoji-picker {
  width: 340px;
  position: relative;
}

/* Add arrow styles */
.emoji-picker-arrow {
  position: absolute;
  bottom: -8px;
  left: 20px;
  transform: translateX(-50%);
  width: 16px;
  height: 8px;
  overflow: hidden;
}

.emoji-picker-arrow::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  background: white;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  top: 0;
  left: 50%;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);
}

.emoji-content {
  max-height: 300px;
  overflow-y: auto;
}

.emoji-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 2px;
}

.btn-emoji {
  border: none;
  background: none;
  font-size: 1.25rem;
  line-height: 1;
  padding: 4px;
  transition: background-color 0.15s ease-in-out;
}

.btn-emoji:hover {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.btn-link {
  text-decoration: none;
}

.btn-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

/* Custom scrollbar styles */
.emoji-content::-webkit-scrollbar {
  width: 8px;
}

.emoji-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.emoji-content::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.emoji-content::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
</style>
